var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterAvailableDescIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9997 13.5006C13.9997 13.6332 13.947 13.7604 13.8532 13.8542C13.7594 13.948 13.6323 14.0006 13.4997 14.0006H7.49965C7.36705 14.0006 7.23987 13.948 7.1461 13.8542C7.05233 13.7604 6.99965 13.6332 6.99965 13.5006C6.99965 13.368 7.05233 13.2408 7.1461 13.1471C7.23987 13.0533 7.36705 13.0006 7.49965 13.0006H12.2927L2.14565 2.85463C2.09917 2.80814 2.06229 2.75295 2.03713 2.69221C2.01197 2.63148 1.99902 2.56638 1.99902 2.50063C1.99902 2.43489 2.01197 2.36979 2.03713 2.30905C2.06229 2.24831 2.09917 2.19312 2.14565 2.14663C2.19214 2.10014 2.24733 2.06327 2.30807 2.03811C2.36881 2.01295 2.43391 2 2.49966 2C2.5654 2 2.6305 2.01295 2.69124 2.03811C2.75198 2.06327 2.80717 2.10014 2.85366 2.14663L12.9997 12.2936V7.50063C12.9997 7.36802 13.0523 7.24085 13.1461 7.14708C13.2399 7.05331 13.367 7.00063 13.4997 7.00063C13.6323 7.00063 13.7594 7.05331 13.8532 7.14708C13.947 7.24085 13.9997 7.36802 13.9997 7.50063V13.5006Z",
    fill: "#242424"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterAvailableDescIcon);
export default __webpack_public_path__ + "static/media/filter-available-desc-icon.1c9b240cc58b7f6e7d5ec2d671fd242e.svg";
export { ForwardRef as ReactComponent };